import React, { useState, useEffect } from 'react';
import AppSidebar from './Sidebar';
import { useAuth } from '../contexts/AuthContext';
import { Client, Databases, Storage, Query } from 'appwrite';

const client = new Client();
client.setEndpoint('https://cloud.appwrite.io/v1').setProject('67fbee6a001260770104');

const databases = new Databases(client);
const storage = new Storage(client);

const DATABASE_ID = '68098bc80034d68e4e64';
const COLLECTION_ID = '68098bd900226cbeb1cd';
const BUCKET_ID = '680990d6000f00f9d400';

const MyContent = () => {
  const { currentUser } = useAuth();
  const [contentType, setContentType] = useState('Poem');
  const [contents, setContents] = useState([]);
  const contentTypes = ['Poem', 'Story', 'Essay', 'Knowledge Hub', 'Scholarship'];

  const fetchContents = async () => {
    if (!currentUser) return;
    try {
      const response = await databases.listDocuments(DATABASE_ID, COLLECTION_ID, [
        Query.equal('userId', currentUser.uid),
        Query.equal('contentType', contentType),
        Query.orderDesc('createdAt'),
      ]);
      setContents(response.documents);
    } catch (error) {
      console.error('Error fetching content:', error);
    }
  };

  useEffect(() => {
    fetchContents();
  }, [currentUser, contentType]);

  const getImageUrl = (imageId) => {
    if (!imageId) return null;
    try {
      return storage.getFileView(BUCKET_ID, imageId);
    } catch (error) {
      console.error('Error loading image:', error);
      return '';
    }
  };

  if (!currentUser) return <div>Loading...</div>;

  return (
    <div className="flex">
      <div className="sticky top-0 h-screen">
        <AppSidebar user={currentUser} />
      </div>
      <div className="ml-20 md:ml-0 p-6 bg-gray-100 min-h-screen w-full">
        <h1 className="text-2xl font-bold mb-4">My {contentType}s</h1>

        {/* Filter buttons */}
        <div className="mb-6 flex flex-wrap gap-2">
          {contentTypes.map((type) => (
            <button
              key={type}
              onClick={() => setContentType(type)}
              className={`px-4 py-2 rounded-full text-sm font-medium transition duration-200 ${
                contentType === type ? 'bg-blue-600 text-white' : 'bg-gray-200 text-gray-700'
              }`}
            >
              {type}
            </button>
          ))}
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {contents.length > 0 ? (
            contents.map((item) => (
              <div key={item.$id} className="bg-white rounded-lg shadow-md overflow-hidden">
                {item.imageId && (
                  <img
                    src={getImageUrl(item.imageId)}
                    alt={item.title}
                    className="h-48 w-full object-cover"
                    onError={(e) => (e.target.src = 'https://via.placeholder.com/400x200?text=Image+Not+Found')}
                  />
                )}
                <div className="p-4">
                  <h2 className="text-xl font-bold mb-2">{item.title}</h2>
                  {item.category && (
                    <div className="mb-2">
                      <span className="bg-blue-100 text-blue-800 text-xs font-medium px-2.5 py-0.5 rounded-full">
                        {item.category}
                      </span>
                    </div>
                  )}
                  {item.deadline && (
                    <p className="text-sm text-gray-600 mb-2">Deadline: {item.deadline}</p>
                  )}
                  <div className="mb-2">
                    {item.isApproved ? (
                      <span className="text-green-600 text-sm font-semibold">Approved ✅</span>
                    ) : (
                      <span className="text-red-500 text-sm font-semibold">Not Approved ❌</span>
                    )}
                  </div>
                  <p className="text-gray-700 whitespace-pre-line">{item.content}</p>
                </div>
              </div>
            ))
          ) : (
            <p>No {contentType.toLowerCase()}s found.</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default MyContent;
